<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
  xml:space="preserve"
>
  <path
    fill="#af6328"
    d="m325.109 86.828-56-80a15.996 15.996 0 0 0-26.218 0l-56 80A16.015 16.015 0 0 0 184 96v400c0 8.836 7.164 16 16 16h112c8.836 0 16-7.164 16-16V96c0-3.281-1.012-6.484-2.891-9.172zM149.109 86.828l-56-80a15.996 15.996 0 0 0-26.218 0l-56 80A16.015 16.015 0 0 0 8 96v400c0 8.836 7.164 16 16 16h112c8.836 0 16-7.164 16-16V96c0-3.281-1.012-6.484-2.891-9.172z"
  />
  <path
    fill="#a25425"
    d="M232 360c-4.422 0-8-3.578-8-8V216c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v136c0 4.422-3.578 8-8 8zM280 328c-4.422 0-8-3.578-8-8v-56c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM248 128c-4.422 0-8-3.578-8-8V64c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM224 472c-4.422 0-8-3.578-8-8v-56c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8z"
  />
  <path
    fill="#af6328"
    d="m501.109 86.828-56-80a15.996 15.996 0 0 0-26.218 0l-56 80A16.015 16.015 0 0 0 360 96v400c0 8.836 7.164 16 16 16h112c8.836 0 16-7.164 16-16V96c0-3.281-1.012-6.484-2.891-9.172z"
  />
  <path
    fill="#e2e4e6"
    d="M448 400c0 8.844-7.164 16-16 16s-16-7.156-16-16c0-8.843 7.164-16 16-16s16 7.157 16 16z"
  />
  <path
    fill="#a25425"
    d="M432 416c-7.447 0-13.651-5.107-15.435-12-.333 1.286-.565 2.61-.565 4 0 8.844 7.164 16 16 16s16-7.156 16-16c0-1.39-.232-2.714-.565-4-1.784 6.893-7.988 12-15.435 12zM432 192c-7.447 0-13.651-5.107-15.435-12-.333 1.286-.565 2.61-.565 4 0 8.844 7.164 16 16 16s16-7.156 16-16c0-1.39-.232-2.714-.565-4-1.784 6.893-7.988 12-15.435 12z"
  />
  <path
    fill="#e2e4e6"
    d="M448 176c0 8.844-7.164 16-16 16s-16-7.156-16-16c0-8.843 7.164-16 16-16s16 7.157 16 16zM272 400c0 8.844-7.164 16-16 16s-16-7.156-16-16c0-8.843 7.164-16 16-16s16 7.157 16 16z"
  />
  <path
    fill="#7d4b22"
    d="M256 416c-7.447 0-13.651-5.107-15.435-12-.333 1.286-.565 2.61-.565 4 0 8.844 7.164 16 16 16s16-7.156 16-16c0-1.39-.232-2.714-.565-4-1.784 6.893-7.988 12-15.435 12zM256 192c-7.447 0-13.651-5.107-15.435-12-.333 1.286-.565 2.61-.565 4 0 8.844 7.164 16 16 16s16-7.156 16-16c0-1.39-.232-2.714-.565-4-1.784 6.893-7.988 12-15.435 12z"
  />
  <path
    fill="#e2e4e6"
    d="M272 176c0 8.844-7.164 16-16 16s-16-7.156-16-16c0-8.843 7.164-16 16-16s16 7.157 16 16zM96 400c0 8.844-7.164 16-16 16s-16-7.156-16-16c0-8.843 7.164-16 16-16s16 7.157 16 16z"
  />
  <path
    fill="#a25425"
    d="M80 416c-7.447 0-13.651-5.107-15.435-12-.333 1.286-.565 2.61-.565 4 0 8.844 7.164 16 16 16s16-7.156 16-16c0-1.39-.232-2.714-.565-4-1.784 6.893-7.988 12-15.435 12zM80 192c-7.447 0-13.651-5.107-15.435-12-.333 1.286-.565 2.61-.565 4 0 8.844 7.164 16 16 16s16-7.156 16-16c0-1.39-.232-2.714-.565-4-1.784 6.893-7.988 12-15.435 12z"
  />
  <path
    fill="#e2e4e6"
    d="M96 176c0 8.844-7.164 16-16 16s-16-7.156-16-16c0-8.843 7.164-16 16-16s16 7.157 16 16z"
  />
  <path
    fill="#a25425"
    d="M488 112v376a8 8 0 0 1-8 8h-88c-8.837 0-16 7.163-16 16h112c8.837 0 16-7.163 16-16V96c-8.837 0-16 7.163-16 16zM312 112v376a8 8 0 0 1-8 8h-88c-8.837 0-16 7.163-16 16h112c8.837 0 16-7.163 16-16V96c-8.837 0-16 7.163-16 16zM136 112v376a8 8 0 0 1-8 8H40c-8.837 0-16 7.163-16 16h112c8.837 0 16-7.163 16-16V96c-8.837 0-16 7.163-16 16zM336 152h24v56h-24zM408 360c-4.422 0-8-3.578-8-8V216c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v136c0 4.422-3.578 8-8 8z"
  />
  <path
    fill="#a25425"
    d="M456 328c-4.422 0-8-3.578-8-8v-56c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM424 128c-4.422 0-8-3.578-8-8V64c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM400 472c-4.422 0-8-3.578-8-8v-56c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM56 360c-4.422 0-8-3.578-8-8V216c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v136c0 4.422-3.578 8-8 8zM104 328c-4.422 0-8-3.578-8-8v-56c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM72 128c-4.422 0-8-3.578-8-8V64c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8zM48 472c-4.422 0-8-3.578-8-8v-56c0-4.422 3.578-8 8-8 4.422 0 8 3.578 8 8v56c0 4.422-3.578 8-8 8z"
  />
  <path fill="#7f4122" d="M328 152h8v56h-8z" />
  <path fill="#a25425" d="M160 152h24v56h-24z" />
  <path fill="#7f4122" d="M152 152h8v56h-8z" />
  <path fill="#a25425" d="M160 368h24v56h-24z" />
  <path fill="#7f4122" d="M152 368h8v56h-8z" />
  <path fill="#a25425" d="M336 368h24v56h-24z" />
  <path fill="#7f4122" d="M328 368h8v56h-8z" />
</svg>
